import 'bootstrap/dist/css/bootstrap.css';
import AuthenticationService from '../authentication/AuthenticationService';

const Logout = (props) => {
    AuthenticationService.logout();
    return(
        window.location.href = "/"
    )
}
export default Logout